import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import type { Campaign } from "@/pages/mill/schedule/models/Campaign";

type Props = {
	setSelectedRowData: (campaign: Campaign | null) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
};

export const useM1CampaignOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: Campaign) => {
		let options: MenuOptionType[] = [];
		if (data) {
			options = options.concat([
				{
					name: "Delete Campaign",
					key: "delete_campaign",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
